import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { openDialog } from '../../actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

//components
import FloatNumberFormatInput from '../../components/float_number_input_formatter';

const styles = theme => ({
    paperContainer: {
        width: '100%',
    },
    paperItem: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignContent: 'center',
        padding: '5px 20px 5px 35px',
        boxShadow: 'none',
        border: 0,
    },
    inputImporte: {
        textAlign: 'right',
        margin: theme.spacing(1),
        padding: 0,
        fontSize: 11,
    },
    leftSide: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '50%',
        maxWidth: 190,
    },
    label: {
        textAlign: 'left',
        marginRight: 5,
        fontSize: 13,
    },
    input: {
        width: 75,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '50%',
        alignItems: 'center',
    },
    button: {
        padding: '0 5px',
        marginLeft: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 0,
        fontSize: 12,
        // minWidth: 40,
        width: '46%',
        minWidth: 45,
        height: 20,
        '&:hover': {
            backgroundColor: '#cc8ebf'
        },
        boxShadow: '1px 1px 1px darkgrey',
        overflow: 'hidden'
    },
});

class CierreSemanalResumenItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    generateButton = () => {

        const { classes } = this.props;

        switch (this.props.item.orden) {
            case 2:
                return (
                    <div>
                        <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreSemanalResumenVisas', {
                        }, uuidv4(), true, "sm")}>
                            {'...'}
                        </Button>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreSemanalResumenGastos', {
                        }, uuidv4(), true, "sm")}>
                            {'...'}
                        </Button>
                    </div>
                );
            case 5:
                return (
                    <div>
                        <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreSemanalResumenMKT', {
                        }, uuidv4(), true, "md")}>
                            {'...'}
                        </Button>
                    </div>
                );
            case 100:
                return (
                    <div>
                        <Button variant="contained" size="small" className={classes.button} fullWidth onClick={() => this.props.openDialog('CierreSemanalResumenBanco', {
                            gastos: this.props.gastosGeneral,
                            arcadeCompl: this.props.arcadeCompl
                        }, uuidv4(), true, "xs")}>
                            {'...'}
                        </Button>
                    </div>
                );
            default:
                return (<div></div>);
        }
    }


    renderLabel = () => {

        let label = '';

        switch (this.props.item.orden) {
            case 1:
                label = 'Total Ingresos';
                break;
            case 2:
                label = 'Visas';
                break;
            case 3:
                label = 'Gastos';
                break;
            case 4:
                label = 'Var. Fondo';
                break;
            case 5:
                label = 'MKT Pdte.';
                break;
            case 100:
                label = 'Bancos';
                break;
            case 101:
                label = 'Arcade';
                break;
            default:
                break;
        }

        return label;
    };

    render() {
        const { classes } = this.props;

        return (
            <form key={'item'} className={classes.paperContainer} >
                <div className={classes.paperItem} >

                    <div className={classes.leftSide}>
                        <Typography variant="subtitle2" className={classes.label}>{this.renderLabel()}</Typography>
                        <TextField
                            id='importe'
                            placeholder='Importe'
                            //value={this.props.item.orden === 100 ? this.props.item.importe + this.props.gastosGeneral : this.props.item.importe}
                            value={this.props.item.orden === 100 ? parseFloat(this.props.item.importe.toFixed(2)) + this.props.arcadeCompl + this.props.gastosGeneral : this.props.item.importe}
                            variant="outlined"
                            disabled
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                        />
                    </div>

                    <div className={classes.buttonContainer}>
                        {this.generateButton()}
                    </div>
                </div>
            </form>
        );
    }
}


CierreSemanalResumenItem.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    //parameters
    item: PropTypes.object.isRequired

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        openDialog
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalResumenItem));